// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page":"css-2_VKGCH7eZ"};